module.exports = __webpack_public_path__ + "img/goods10_1.f1b71a08.jpg";